var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontpageLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 922.246,
    viewBox: "0 0 193 922.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M1275,1120.123V197.877a610.285,610.285,0,0,1,42.319,44.939,620.754,620.754,0,0,1,37.835,49.327c11.81,17.111,22.911,35.055,32.993,53.335,10.152,18.405,19.5,37.571,27.795,56.964,8.369,19.574,15.852,39.833,22.24,60.213a649.528,649.528,0,0,1,16.327,63.084,657.871,657.871,0,0,1,10.058,65.575,669.159,669.159,0,0,1,0,135.374,657.844,657.844,0,0,1-10.058,65.575,649.569,649.569,0,0,1-16.327,63.084c-6.388,20.38-13.871,40.639-22.24,60.213-8.292,19.393-17.643,38.559-27.795,56.964-10.083,18.28-21.183,36.224-32.993,53.335a620.771,620.771,0,0,1-37.835,49.327A610.271,610.271,0,0,1,1275,1120.121Z",
    transform: "translate(-1275 -197.877)",
    fill: "#edf8f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageLeft);
export default __webpack_public_path__ + "static/media/frontpage_left.2721a810d4c4d6d7ce128c2fe11f7f5c.svg";
export { ForwardRef as ReactComponent };